import { Female, Male, Save, Close, Folder } from '@mui/icons-material'
import { Avatar, Box, Button, Card, CardContent, CardHeader, FormControl, Grid, InputLabel, MenuItem, Select, Stack, TextField, Typography, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { formatoNum } from '../../lib/format'

const SociosTab = ({ socios, imagenes, editable, setData, handleUpdate }) => {
    //console.log(socios);
    const [catalogoFiguras, setCatalogoFiguras] = useState([]);
    const init = async () => {
        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/figuras_juridicas_organismos`)
            .then(res => res.json())
            .then((res) => {
                // console.log(res);
                setCatalogoFiguras(res.data);
            });
    }
    const handleFigura = (e, index) => {
        let newData = socios.map((s, i) => {
            if (i == index) {
                s.figura_juridica = e.target.value
            }
            return s
        })
        setData({ target: { name: 'socios', value: newData } })
    }
    const handleQtys = (e, type, index) => {
        let newData = socios.map((s, i) => {
            if (i == index) {
                s[type] = parseInt(e.target.value)
            }
            return s
        })
        setData({ target: { name: 'socios', value: newData } });
    };

    const addFigura = () => {
        setData({
            target: {
                name: 'socios',
                value: [
                    ...socios,
                    {
                        figura_juridica: '',
                        cant_empresas_sociales: '', // empresas u organizaciones sociales
                        cant_personas_asociadas: '' // personas asociadas    
                    }
                ]
            }
        })
    };

    const handleInput = (e) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result;
                imagen.paso = 'total_socios';
                setData({
                    target: { name: 'imagenes', value: [...imagenes, imagen] }
                });
            };
            reader.readAsDataURL(imagen);
        }
    };

    const removeImg = (imgurl, isNew = false) => {
        setData({ target: { name: 'imagenes', value: imagenes.filter(img => (isNew ? img.dataurl : img.url_img) !== imgurl) } });
    }
    useEffect(() => { init(); }, []);
    if (socios && catalogoFiguras.length > 0) {
        return (
            <Box sx={{ m: 2 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={12}>
                        {editable ?
                            <Box sx={{ gap: 1 }}>
                                <Grid container spacing={2}>
                                    {socios.map((socio, index) => (
                                        <Grid item xs={12} key={index}>
                                            <Box>
                                                <FormControl fullWidth margin="normal">
                                                    <InputLabel id="figura_juridica" required>Figura Jurídica {index + 1} de las empresas u organizaciones</InputLabel>
                                                    <Select
                                                        labelId="figura_juridica"
                                                        name="figura_juridica"
                                                        value={socio.figura_juridica}
                                                        label={`Figura Jurídica ${index + 1} de las empresas u organizaciones`}
                                                        onChange={(e) => handleFigura(e, index)}
                                                    >
                                                        {/* Obtener catalogo de figuras jurídicas */}
                                                        {catalogoFiguras.map((figura) => (
                                                            <MenuItem key={figura.id} value={figura.id}>
                                                                {figura.nombre}
                                                            </MenuItem>
                                                        ))}
                                                        <MenuItem key="otro" value="otro">Otro</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                <Stack direction="row" spacing={1}>
                                                    <TextField
                                                        fullWidth
                                                        onChange={(e) => handleQtys(e, 'cant_empresas_sociales', index)}
                                                        value={socio.cant_empresas_sociales}
                                                        label="Cantidad de empresas u organizaciones sociales"
                                                        type="number"
                                                        margin="normal"
                                                    />
                                                    <TextField
                                                        fullWidth
                                                        onChange={(e) => handleQtys(e, 'cant_personas_asociadas', index)}
                                                        value={socio.cant_personas_asociadas}
                                                        label="Cantidad de personas asociadas"
                                                        type="number"
                                                        margin="normal"
                                                    />
                                                </Stack>

                                            </Box>
                                        </Grid>
                                    ))}
                                    <Grid item xs={12}>
                                        <Button onClick={addFigura} variant="contained" fullWidth>
                                            Agregar figura
                                        </Button>
                                    </Grid>
                                </Grid>

                                <Box sx={{ mx: 2, pt: 2 }}>
                                    <Typography variant="h6">Fotogalería de las instalaciones*</Typography>
                                    <Typography variant="subtitle1">(Máximo 20 fotografías)</Typography>
                                </Box>
                            </Box>
                            : socios.map((socio, index) => {
                                let figura = catalogoFiguras.find((i) => i.id == socio.figura_juridica);
                                if (figura) {
                                    return (
                                        <Box sx={{ mb: 2 }}>
                                            <Typography variant="h5" sx={{ my: 2 }}>Socios #{index + 1}</Typography>
                                            <Typography fontWeight="bold">Figura Jurídica:</Typography>
                                            <Typography>{figura.nombre}</Typography>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                <Stack spacing={1}>
                                                    <Typography fontWeight="bold">Cantidad de empresas sociales</Typography>
                                                    <Typography sx={{ ml: 2, mr: 4 }}>
                                                        {formatoNum(socio.cant_empresas_sociales)}
                                                    </Typography>
                                                </Stack>
                                                <Stack spacing={1}>
                                                    <Typography fontWeight="bold">Cantidad de personas asociadas</Typography>
                                                    <Typography sx={{ ml: 2, mr: 2 }}>
                                                        {formatoNum(socio.cant_personas_asociadas)}
                                                    </Typography>
                                                </Stack>
                                            </Box>
                                        </Box>
                                    )
                                }
                            })
                        }
                    </Grid>

                </Grid>
                {editable ?
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        <Grid container spacing={2} sx={{ mx: 2, mt: 2 }}>
                            {Object.values(imagenes).filter((i) => i.paso == 'total_socios').map((image, index) => (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    key={index}
                                    sx={{ position: 'relative', border: 1, borderColor: '#e0dcda', display: 'flex', alignItems: 'center' }}>
                                    <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => image.url_img ? removeImg(image.url_img) : removeImg(image.dataurl, true)}>
                                        <Close />
                                    </IconButton>
                                    <img src={image.url_img ?? image.dataurl} alt={image.name} width="300px" />
                                </Grid>
                            ))}
                            <Grid item xs={12}>
                                <Button
                                    disabled={imagenes.filter((i) => i.paso == 'total_socios').length > 19}
                                    component="label"
                                    variant="contained"
                                    startIcon={<Folder />}
                                >
                                    Agregar <input name="imagenes" onInputCapture={handleInput} type="file" accept='image/*' hidden />
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                    :
                    <Box sx={{ my: 2 }}>
                        <Typography sx={{ mb: 2 }} variant="h6">Fotogalería de las Empresas y/u Organizaciones sociales del organismo:</Typography>
                        <Grid container spacing={2}>
                            {Object.values(imagenes)
                                .filter((i) => i.paso === 'total_socios')
                                .map((img, index) => {
                                    return (
                                        <Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            key={index}
                                            sx={{ display: 'flex', justifyContent: 'center' }}
                                        >
                                            <img
                                                src={img.url_img ?? img.dataurl}
                                                width="100%"
                                                alt={index}
                                                style={{ maxWidth: '300px', objectFit: 'contain' }}
                                            />
                                        </Grid>
                                    )
                                })}
                        </Grid>
                    </Box>
                }
                {/* Boton para actualizar datos de este tab */}
                {
                    editable &&
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                        <Button variant="contained" color="success" startIcon={<Save />} onClick={handleUpdate} >Guardar esta sección</Button>
                    </Box>
                }

            </Box >
        )
    }
}
export default SociosTab